import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataStockSymbol } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

export const MASTERDATA_STOCK_SYMBOL =
  defineMasterdataEntity<MasterdataStockSymbol>({
    name: 'stock-symbol',
    responseKey: 'stockSymbols',
    displayWith: (s) => keyName(s.key, s.name),
    defaultFilter: ACTIVE_ONLY,
    icon: 'fa-regular fa-boxes-stacked',
    title: 'Lagersymbolsuche',
    label: 'Lagersymbol',
    placeholder: 'Lagersymbol suchen...',
    columns: [
      {
        label: 'Lagersymbol',
        type: 'entity',
        icon: 'fa-regular fa-boxes-stacked',
        value: (e) => keyName(e.key, e.name),
      },
      { label: 'Schlüssel', type: 'text', value: (e) => e.key },
      { label: 'Bezeichnung', type: 'text', value: (e) => e.name },
      { label: 'Lagerwirkung', type: 'text', value: (e) => e.stockEffect },
      {
        label: 'Kalkulationsrelevant',
        type: 'text',
        value: (e) => (e.costingRelevant ? 'Ja' : 'Nein'),
      },
      { label: 'Belegart', type: 'text', value: (e) => e.documentType },
      { label: 'Erfassungsumfang', type: 'text', value: (e) => e.recordScope },
      { label: 'Aktiv', type: 'text', value: (e) => (e.active ? 'Ja' : 'Nein') },
      { label: 'Palettenhandling', type: 'text', value: (e) => e.palletHandling },
      {
        label: 'Schwundbilanzrelevant',
        type: 'text',
        value: (e) => (e.wasteBalanceRelevant ? 'Ja' : 'Nein'),
      },
    ],
  });
